exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.half-circle-spinner[data-v-1b6af564], .half-circle-spinner *[data-v-1b6af564] {\n  box-sizing: border-box;\n}\n.half-circle-spinner[data-v-1b6af564] {\n  width: 60px;\n  height: 60px;\n  border-radius: 100%;\n  position: relative;\n}\n.half-circle-spinner .circle[data-v-1b6af564] {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  border: calc(60px / 10) solid transparent;\n}\n.half-circle-spinner .circle.circle-1[data-v-1b6af564] {\n  border-top-color: #ff1d5e;\n  animation: half-circle-spinner-animation 1s infinite;\n}\n.half-circle-spinner .circle.circle-2[data-v-1b6af564] {\n  border-bottom-color: #ff1d5e;\n  animation: half-circle-spinner-animation 1s infinite alternate;\n}\n@keyframes half-circle-spinner-animation {\n0% {\n    transform: rotate(0deg);\n}\n100%{\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1b6af564","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/epic-spinners/src/components/lib/HalfCircleSpinner.vue
// module id = 572
// module chunks = 0